const setupAxiosInterceptors = (store, router, axiosInstance) => {
    // create an interceptor to add token to requests towards the API.
    axiosInstance.interceptors.request.use(config => {
        const token = store.state.token;

        store.commit('setLoading', true);
        // add or remove token from requests based on state
        if(token) config.headers['x-access-token'] = token
        else delete config.headers['x-access-token'] // remove token from default headers if we are logged out or no token exists in state

        return config;
    }, err => {
        store.commit('setLoading', false);
        return Promise.reject(err);
    });

    axiosInstance.interceptors.response.use(response => {
        store.commit('setLoading', false);
        return response;
    }, err => {
        store.commit('setLoading', false);
        if(err.response && err.response.status === 401){
            return store.dispatch('logout').then(()=>{
                router.push({name: 'login'});
            });
        }else{
            return Promise.reject(err);
        }

    });
}
module.exports = {
    setupAxiosInterceptors
}